<div class="px-10 sm:px-0 grid grid-cols-1 gap-y-[110px] h-full w-full">
    <section id="carrier-resources-spot-market"
        class="grid grid-cols-3 sm:grid-cols-1 tablet:grid-cols-1 gap-x-2 sm:justify-items-center tablet:justify-items-center sm:gap-y-2">
        <h2 class="tl-section-header text-white m-0 sm:px-[25px] mb-5 col-span-3 sm:col-span-1 tablet:col-span-1 tablet:justify-self-start sm:justify-self-start">National Spot Rates</h2>
        <h6 class="text-white tl-section-subheader my-0 pb-5 sm:block sm:px-[25px] col-span-3 sm:col-span-1 tablet:col-span-1 tablet:justify-self-start sm:justify-self-start">
            {{spotBlurb()}} </h6>
        <section class="justify-items-center">
            <div class="grid grid-cols-1 gap-y-2" >
                <iq-trendlines-ntl-spot-van></iq-trendlines-ntl-spot-van>
                <strong class="text-white my-2 sm:text-center tablet:text-center"> VAN </strong>
            </div>
        </section>
        <section class="justify-items-center">
            <div class="grid grid-cols-1 gap-y-2">
                <iq-trendlines-ntl-spot-flatbed></iq-trendlines-ntl-spot-flatbed>
                <strong class="text-white my-2 sm:text-center tablet:text-center"> FLATBED </strong>
            </div>
        </section>
        <section class="justify-items-center">
            <div class="grid grid-cols-1 gap-y-2">
                <iq-trendlines-ntl-spot-reefer></iq-trendlines-ntl-spot-reefer>
                <strong class="text-white my-2 sm:text-center tablet:text-center"> REEFER </strong>
            </div>
        </section>
    </section>
    <section id="carrier-resources-fuel-section">
        <h2 class="tl-section-header text-white m-0 mb-5 sm:px-[25px]">Fuel Prices</h2>
        <h6 class="tl-section-subheader m-0 pb-[70px] sm:pb-[50px] sm:px-[25px] text-white">Current national diesel fuel
            price average</h6>
        <iq-trendlines-fuel-card [id]="'carrier-resources-fuel-card'"></iq-trendlines-fuel-card>
    </section>
    <section id="carrier-resources-weekly-snapshot">
        <h2 class="tl-section-header text-white m-0 pb-10 sm:px-[25px]">Weekly snapshot by the numbers</h2>
        <iq-trendlines-snapshot-table [id]="'carrier-resources-weekly-snapshot'"></iq-trendlines-snapshot-table>
    </section>
</div>